import { IconWrapper } from '../runtime';
export default IconWrapper('archive-format', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 25 24",
      "fill": "none"
    }
  }, [h("path", {
    "attrs": {
      "d": "M0.5 3.75C0.5 1.67893 2.17893 0 4.25 0H20.75C22.8211 0 24.5 1.67893 24.5 3.75V20.25C24.5 22.3211 22.8211 24 20.75 24H4.25C2.17893 24 0.5 22.3211 0.5 20.25V3.75Z",
      "fill": 'url(#' + props.id + '345e4713' + ')'
    }
  }), h("path", {
    "attrs": {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M9.875 9C9.25368 9 8.75 9.50368 8.75 10.125V15V16.5C8.75 16.9142 9.08579 17.25 9.5 17.25H12.5V19.5H9.5C9.08579 19.5 8.75 19.8358 8.75 20.25V21C8.75 21.4142 9.08579 21.75 9.5 21.75H12.5V24H15.5C15.9142 24 16.25 23.6642 16.25 23.25V22.5C16.25 22.0858 15.9142 21.75 15.5 21.75H12.5V19.5H15.5C15.9142 19.5 16.25 19.1642 16.25 18.75V18C16.25 17.5858 15.9142 17.25 15.5 17.25H12.5V15H15.125C15.7463 15 16.25 14.4963 16.25 13.875V10.125C16.25 9.50368 15.7463 9 15.125 9H9.875ZM14.1875 11.0625H10.8125V12.9375H14.1875V11.0625Z",
      "fill": "white"
    }
  }), h("defs", [h("linearGradient", {
    "attrs": {
      "id": props.id + '345e4713',
      "x1": "0.5",
      "y1": "0",
      "x2": "24.5",
      "y2": "24",
      "gradientUnits": "userSpaceOnUse"
    }
  }, [h("stop", {
    "attrs": {
      "stop-color": "#8497B8"
    }
  }), h("stop", {
    "attrs": {
      "offset": "1",
      "stop-color": "#60718D"
    }
  })])])]);
});